import { render } from "./gmAbnormalCallList.vue?vue&type=template&id=12dde4bf&scoped=true"
import script from "./gmAbnormalCallList.vue?vue&type=script&lang=js"
export * from "./gmAbnormalCallList.vue?vue&type=script&lang=js"

import "./gmAbnormalCallList.vue?vue&type=style&index=0&id=12dde4bf&scoped=true&lang=css"
import "./gmAbnormalCallList.vue?vue&type=style&index=1&id=12dde4bf&lang=css"
script.render = render
script.__scopeId = "data-v-12dde4bf"

export default script